import { AccessRoleDetails } from "../../../../domain/access-role";
import { OrganizationDetails } from "../../../../domain/organization";
import { FormlyFieldConfigTranslatable } from "../../../../shared/types/form";

interface EditFormFieldsOptions {
  orgData: OrganizationDetails;
  companyName: string;
  accessRoles: AccessRoleDetails[];
}

export function getEditFormFields(options: EditFormFieldsOptions): FormlyFieldConfigTranslatable[] {
  const { orgData, companyName, accessRoles } = options;
  return [
    {
      fieldGroupClassName: "flex flex-col gap-5", // Managing the gap between the fields
      fieldGroup: [
        {
          key: "firstName",
          type: "text",
          props: {
            disabled: true,
            label: {
              en: "First name",
              fi: "Etunimi",
              sv: "Förnamn",
              no: "Fornavn",
            },
            required: true,
          },
        },
        {
          key: "lastName",
          type: "text",
          props: {
            disabled: true,
            label: {
              en: "Last name",
              fi: "Sukunimi",
              sv: "Efternamn",
              no: "Etternavn",
            },
            required: true,
          },
        },
        {
          key: "emailAddress",
          type: "text",
          props: {
            disabled: true,
            type: "email",
            label: {
              en: "Email address",
              fi: "Sähköpostiosoite",
              sv: "E-postadress",
              no: "E-postadresse",
            },
            required: true,
            description: {
              en: `Contact ${companyName} staff to change email`,
              fi: `Ota yhteyttä ${companyName} henkilökuntaan muuttaaksesi sähköpostia`,
              sv: `Kontakta ${companyName} personal för att ändra e-post`,
              no: `Kontakt ${companyName}-personalet for å endre e-post`,
            },
          },
          validators: {
            validation: ["email"],
          },
        },
        // AccessRole dropdown
        {
          key: "accessRoleId",
          type: "select",
          props: {
            required: true,
            label: {
              en: "Access Role",
              fi: "Käyttöoikeusrooli",
              sv: "Åtkomstroll",
              no: "Tilgangsrolle",
            },
            options: accessRoles.map((role) => ({
              value: role.id,
              label: role.name,
            })),
          },
          expressions: {
            "props.disabled": (config) => config.options?.formState.disabled,
          },
        },
        {
          key: "defaultApprovalGroupId",
          type: "select",
          props: {
            label: {
              en: "Process Approvers",
              fi: "Prosessien hyväksyjät",
              sv: "Processförhandlare",
              no: "Prosessgodkjennere",
            },
            description: {
              en: "This approval group will be automatically selected for all processes that require approval and are started by this user.",
              fi: "Tämä hyväksyntäryhmä asetetaan automaattisesti kaikkiin prosesseihin, jotka vaativat hyväksynnän ja jotka tämä käyttäjä aloittaa.",
              sv: "Denna godkännande grupp kommer att väljas automatiskt för alla processer som kräver godkännande och som den här användaren startar.",
              no: "Denne godkjenningsgruppen vil automatisk bli valgt for alle prosesser som krever godkjenning og som startes av denne brukeren.",
            },

            options: orgData.approvalGroups.map((approvalGroup) => ({
              value: approvalGroup.id,
              label: { en: approvalGroup.name, fi: approvalGroup.name, sv: approvalGroup.name, no: approvalGroup.name },
            })),
          },
          expressions: {
            "props.disabled": (config) => config.options?.formState.disabled,
          },
        },
      ],
    },
  ];
}
